import { GET_TEMPLATES } from '../actions/template/types';

let initialState = {}

export default function( state = initialState, action){
    switch(action.type){
      case GET_TEMPLATES :
        return {...action.payload}
      default :
        return state;
    }
}